import { combineEpics, Epic } from 'redux-observable';

import { authEpics } from 'redux/auth';
import { toastEpics } from 'redux/toast';

export const epics: Epic = combineEpics(authEpics, toastEpics);
